/**
 * Quizz Presentational Component
 * View: Displays an episode Quizz
 */

require('../styles/bd.scss');

import React from 'react';
import LimelightVideo from './limelight';

const BD = ({bg, video}) => {
  if(bg){
    return (
      <div className="bd-container" >
        <img className="bd-image" src={bg} />
        <div id="limelight_player_260773"></div>
        {(()=> {
          if(video && video.limelightMediaId){
            var limelightPlayerId = 'limelight_player_' + (video.limelightPlayerId?video.limelightPlayerId:797509);

            return(
              <LimelightVideo
                id={limelightPlayerId}
                source={video.limelightMediaId}
                width="480"
                height="320"
              />
            )
          }
        })()}
      </div>
    )
  }else{
    return null
  }
}

export default BD;



// WEBPACK FOOTER //
// ./src/components/BD.js